var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183,
    height: 155,
    fill: "none",
    viewBox: "0 0 183 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.782,
    height: 15.309,
    x: 55.754,
    y: 126.959,
    fill: "#E6E6E6",
    rx: 7.654,
    transform: "rotate(-30 55.754 126.959)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.873,
    height: 15.292,
    x: 7.646,
    y: 101.684,
    fill: "#E6E6E6",
    rx: 7.646,
    transform: "rotate(-30 7.646 101.684)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.309,
    height: 15.309,
    x: 131.16,
    y: 12.717,
    fill: "#E6E6E6",
    rx: 7.654,
    transform: "rotate(-30 131.16 12.717)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillRule: "evenodd",
    d: "M34.93 68.275a7.654 7.654 0 107.655 13.257l4.323-2.496.114-.067 26.164-15.105A7.654 7.654 0 1180.84 77.12L61.74 88.15l.048-.028 61.81-35.686.086-.05-1.226.708a7.654 7.654 0 01-10.456-2.802 7.654 7.654 0 012.801-10.456l5.754-3.322a7.654 7.654 0 00-7.789-13.178L34.93 68.275zm63.122 34.264a7.654 7.654 0 107.654 13.257l45.333-26.173a7.654 7.654 0 002.801-10.456 7.654 7.654 0 00-10.456-2.801l-45.332 26.173zm19.331-28.838l-.442.255c.075-.042.149-.082.225-.12a7.653 7.653 0 00-2.498 10.27 7.654 7.654 0 0010.143 2.973 7.52 7.52 0 01-.303.184l-47.411 27.373-.071.041 10.344-5.972a7.655 7.655 0 00-7.655-13.258L55.721 109.3a7.654 7.654 0 01-7.542-13.321l94.296-54.442a7.654 7.654 0 017.654 13.258l-6.409 3.7a9.606 9.606 0 00-.087.05L117.469 73.65a3.896 3.896 0 00-.086.051z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.39,
    cy: 108.685,
    r: 3.971,
    stroke: "#E6E6E6",
    strokeWidth: 1.912
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.287,
    cy: 44.48,
    r: 2.952,
    stroke: "#E6E6E6",
    strokeWidth: 1.912
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.444,
    cy: 134.548,
    r: 4.527,
    stroke: "#E6E6E6",
    strokeWidth: 1.912
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.515,
    height: 1.699,
    x: 108.508,
    y: 3.908,
    fill: "#E6E6E6",
    rx: 0.85
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 9.515,
    height: 1.699,
    x: 114.115,
    fill: "#E6E6E6",
    rx: 0.85,
    transform: "rotate(90 114.115 0)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.136,
    height: 1.699,
    x: 139.719,
    y: 133.291,
    fill: "#E6E6E6",
    rx: 0.85
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.136,
    height: 1.699,
    x: 144.137,
    y: 130.658,
    fill: "#E6E6E6",
    rx: 0.85,
    transform: "rotate(90 144.137 130.658)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.136,
    height: 1.699,
    x: 9.52,
    y: 83.813,
    fill: "#E6E6E6",
    rx: 0.85
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 7.136,
    height: 1.699,
    x: 13.938,
    y: 81.18,
    fill: "#E6E6E6",
    rx: 0.85,
    transform: "rotate(90 13.938 81.18)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 95.792,
    height: 61.465,
    x: 44.696,
    y: 57.178,
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 2.286,
    rx: 6.857
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.846 27.837v45.361L92.591 87.91l31.876-18.39V46.228h-12.06v-18.39l-5.695 5.216-5.695-5.215-5.695 5.215-5.696-5.215-5.695 5.215-5.695-5.215-5.695 5.215-5.695-5.215z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M91.5 29l4.5 4 5.5-5 6 5 5-4v17h11v12.317h10.228a5.6 5.6 0 015.6 5.6V111.9a5.6 5.6 0 01-5.6 5.6H91.5V29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AFAFAF",
    strokeWidth: 2.286,
    d: "M46.082 61.58L92.9 87.73l46.817-26.15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AFAFAF",
    strokeLinecap: "round",
    strokeWidth: 2.286,
    d: "M103.625 46.227H86.461M80.332 46.227h-3.678M103.625 56.035H86.461M80.332 56.035h-3.678M103.625 65.844H86.461M80.332 65.844h-3.678"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AFAFAF",
    strokeWidth: 2.286,
    d: "M66.847 73.198v-45.36l5.823 5.215 5.823-5.216 5.824 5.216 5.823-5.216 5.823 5.216 5.824-5.216 5.823 5.216 5.824-5.216V75.65M124.467 69.52V46.227h-11.033V69.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.452855ed.svg";
export { ForwardRef as ReactComponent };